import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from "react-router-dom";
import { setPOData, setOrderProperty, setPOType } from '../js/actions/index';

import { Container, Col, Row, Form, Button, Table, Accordion, ListGroup, Alert } from "react-bootstrap";

import NavbarComponent from '../components/NavbarComponent';
import PaginationComponent from '../components/PaginationComponent';
import LoadingComponent from '../components/LoadingComponent';
import ServerErrorComponent from '../components/ServerErrorComponent';
import AuthErrorComponent from '../components/AuthErrorComponent';
import AlertErrorComponent from '../components/AlertErrorComponent';

import { Calendar4, Search, Shop, PersonBoundingBox, XCircle, ExclamationCircle } from 'react-bootstrap-icons';

import moment from 'moment';
import "react-dates/initialize"; 
import { DateRangePicker } from "react-dates"; 
import "react-dates/lib/css/_datepicker.css";

import {formatUTC, getSearchTermMatch} from '../js/global';
import {NO_USER_FOUND, FAILED_AUTHENTICATE_TOKEN} from '../constants/ApiResult';

const axios = require('axios').default;

const orientation = window.matchMedia("(max-width: 700px)").matches ? 'vertical' : 'horizontal';

function mapDispatchToProps(dispatch) {
    return {
        setPOData: data => dispatch(setPOData(data)),
        setOrderProperty: order => dispatch(setOrderProperty(order)),
        setPOType: type => dispatch(setPOType(type))
    };
}

class PurchaseOrderSupplier extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            startDate: moment().subtract(12, "month"),
            endDate: moment(),
            endDateFormatted: moment().format("YYYY-MM-DD HH:mm:ss"),
            startDateFormatted: moment().subtract(12, "month").format("YYYY-MM-DD HH:mm:ss"),
            dataPO:'',
            dataPOFiltered:[],
            restuarantNames:[],
            restuarantSearchTerms:'',
            restuarantSearchTermsSubmit:'',
            paginationActive: 1,
            paginationSize: 15,
            authError:false,
            serverError:false,
            errorAPI:false,
        }
    }

    componentDidMount() {
        this.props.setPOType('confirmed');
        this.getPOHistoryList();
        /*
        if(this.props.poType === "receipted") {
            this.getReceiptedList();
        } else {
            this.getPOHistoryList();
        }
        */
    }

    getPOHistoryList = () => {

        //let poType = this.props.poType ==='unconfirmed' ? 0 : 1;

        axios.get(`${process.env.REACT_APP_API_URL}/api/getPOHistoryList/supplier`,{
            params:{
                state:2,
                supplierId:this.props.auth.supplierId,
                specialStartTime:this.getStartDate().format("YYYY-MM-DD HH:mm:ss"),
                specialEndTime:this.getEndDate().format("YYYY-MM-DD HH:mm:ss")
            },
            headers:{
              'Authorization': `Basic ${this.props.auth.token}` 
            }
        })
        .then( (response) => {
            let res = response.data;

            if([NO_USER_FOUND, FAILED_AUTHENTICATE_TOKEN].indexOf(res.result) > -1) {
                this.setState({
                    authError:true
                });
                return;
            }

            // get all the unique restuarants
            let restuarantNames = [];
            res.data.forEach( (po) => {
                if(restuarantNames.indexOf(po.BranchName) === -1) {
                    restuarantNames.push(po.BranchName);
                }
            });
            
            this.setState({
                dataPO:res.data,
                dataPOFiltered:res.data,
                errorAPI:false,
            }, () => {
                this.props.setPOData({
                    "poType":this.props.poType,
                    "data":res.data
                });
            });

        })
        .catch( (error) => {
            this.setState({
                errorAPI:true,
                isLoading:false
            });
        });        
    }

    getReceiptedList = () => {
        console.log('get receipted list');

        axios.get(`${process.env.REACT_APP_API_URL}/api/getPOReceiptedList/supplier`,{
            params: {
                supplierId:this.props.auth.supplierId,
            },
            headers:{
                'Authorization': `Basic ${this.props.auth.token}` 
            }
        })
        .then( (response) => {
            this.setState({
                isLoading:false,
                dataPO:[],
                dataPOFiltered:[],
                errorAPI:false,
            });
        })
        .catch( (error) => {
            console.error(error.response);
            this.setState({
                errorAPI:true,
                isLoading:false
            });
        });  
    }

    getStartDate = () => {
        if(this.props.order.startDate) {
            return moment(this.props.order.startDate);
        }
        return this.state.startDate;
    }

    getEndDate = () => {
        if(this.props.order.endDate) {
            return moment(this.props.order.endDate);
        }
        return moment();
    }

    handleDateChange = (startDate, endDate) => {
        if(this.state.focusedInput === 'startDate') {
            this.props.setOrderProperty({
                prop:'startDate',
                value:startDate.format("YYYY-MM-DD HH:mm:ss")
            })
        } else if(this.state.focusedInput === 'endDate') {
            this.props.setOrderProperty({
                prop:'endDate',
                value:endDate.format("YYYY-MM-DD HH:mm:ss")
            })
        }
    }

    handlePOClick = (poId) => {
        this.props.history.push('/purchase-order/'+poId);
    }

    handleClickOrderDate = () => {
        this.getPOHistoryList();
    }

    handleChangeRestuarantSearchTerms = (e) => {
        this.setRestuarantSearchTerms(e.currentTarget.value);
    }

    setRestuarantSearchTerms = (searchTerms) => {
        let obj = {
            restuarantSearchTerms:searchTerms
        }
        if(!searchTerms) {
            obj.restuarantSearchTermsSubmit = '';
        }
        this.setState(obj);
    }

    getRestuarantNames = () => {
        // get all the unique restuarants
        let restuarantNames = [];
        this.props[`${this.props.poType}DataPO`].forEach( (po) => {
            if(restuarantNames.indexOf(po.BranchName) === -1) {
                restuarantNames.push(po.BranchName);
            }
        });
        return restuarantNames;
    }

    htmlRestuarantNamesListGroup = () => {
        return (
            <ListGroup className="mt-1" style={{maxHeight:200, overflowY:'auto'}}>
                {this.getRestuarantNames().map((item, index) => 
                    this.filterRestuarantNames(item, index)
                )}
            </ListGroup>
        );
    }

    filterRestuarantNames = (item, index) => {
        let restuarantMatch = getSearchTermMatch(item, this.state.restuarantSearchTerms);
        if( restuarantMatch ) {
            return (
                <ListGroup.Item key={index} onClick={this.handleClickRestuarantItem}>
                    {item}
                </ListGroup.Item>
            );
        } else {
            return false;
        }
    }

    handleClickRestuarantItem = (e) => {
        this.setRestuarantSearchTerms(e.currentTarget.innerHTML);
    }

    handleClickAdvancedSearchSubmit = () => {
        let dataPOFiltered = [];
        this.props[`${this.props.poType}DataPO`].forEach( (row) => {
            let restuarantMatch = getSearchTermMatch(row.BranchName, this.state.restuarantSearchTerms);
            if( restuarantMatch ) {
                dataPOFiltered.push(row);
            }
        });

        this.setState({
            dataPOFiltered:dataPOFiltered,
            restuarantSearchTermsSubmit:this.state.restuarantSearchTerms
        });
    }

    handleClickAdvancedSearchClear = () => {
        this.setState({
            restuarantSearchTerms:"",
            restuarantSearchTermsSubmit:""
        });
    }

    htmlPOReceiptTableRows = () => {
        let start = (this.state.paginationActive - 1) * this.state.paginationSize;
        let end = this.state.paginationActive * this.state.paginationSize;

        let data = this.props[`${this.props.poType}DataPO`];
        if( this.state.restuarantSearchTermsSubmit ) {
            data = this.state.dataPOFiltered;
        }

        let html = data.slice(start, end).map( (row, index) => {

            let date = row.CreateDate.replace(/T/, ' ').replace(/\..+/, '');

            return (
                <tr key={index}>
                    <td>
                    <Button variant="link" type="button" onClick={() => this.handlePOClick(row.POId)}>
                        {row.OrderName}
                    </Button>
                    </td>
                    <td>{formatUTC(date)}</td>
                    <td>{row.BranchName}</td>
                    <td>{row.DepName}</td>
                </tr>
            )
        });
        return html;
    }

    handleClickPaginationItem = (active) => {
        this.setState({
            paginationActive:active
        });
    }

    formatUTC(utc) {
        const formattedDate = new Date(utc)
        .toLocaleDateString({},{timeZone:"UTC",month:"short", day:"2-digit", year:"numeric"})
        
        return formattedDate;
    }

    handlePressPoType = (poType) => {
        if(poType === "confirmed") {
            this.props.setPOType(2)
            .then( () => {
                this.props.history.push('/purchase-orders/approved');
            });
        } else {
            this.props.setPOType(poType);
        }
    }

    render() {
        /*
            Filter by:
            PO name, supplier, restuarant, order date
        */

        if(!this.props[`${this.props.poType}DataPO`]) {
            return (
                <></>
            );
        }

        let data = JSON.parse(JSON.stringify(this.props[`${this.props.poType}DataPO`]));
        let paginationLength = 0;
        let paginationIntervals = 0;        

        if( this.state.restuarantSearchTerms ) {
            data = JSON.parse(JSON.stringify(this.state.dataPOFiltered));
        }

        if(data) {
            paginationLength = data.length;
            paginationIntervals = Math.ceil(data.length / this.state.paginationSize);
        }

        return (
            <Container className="p-0">
                <NavbarComponent />
                <Container fluid>
                    <Row>
                        <Col xs={12}>
                            <div className="mt-4">
                                <h1>Purchase Orders</h1>
                            </div>
        
                            {this.state.serverError
                            
                            ?
                                <ServerErrorComponent />
                            :
                            
                            this.state.authError
                            
                            ?
                                <AuthErrorComponent />
                            :
        
                            this.state.isLoading || (!this.state.dataPO && !this.state.errorAPI)
        
                            ?
                                <LoadingComponent />
                            :
        
                            <div className="mb-4">
        
                                {this.state.errorAPI &&
                                    <div className="mt-4">
                                        <AlertErrorComponent label="Bad Request (400)" /> 
                                    </div>                    
                                }

                            <Row className="mt-4">
                                <Col xs={12}>
                                    <Form>
                                        {['radio'].map((type) => (
                                            <div key={`inline-${type}`}>
                                            <Form.Check inline label="Unconfirmed" type={type} id={`inline-${type}-1`} checked={this.props.poType === "unconfirmed"} onClick={() => this.handlePressPoType('unconfirmed')} disabled />
                                            <Form.Check inline label="Confirmed" type={type} id={`inline-${type}-2`} checked={this.props.poType === "confirmed"} onClick={() => this.handlePressPoType('confirmed')} />
                                            <Form.Check inline label="Receipted" type={type} id={`inline-${type}-3`} checked={this.props.poType === "receipted"} onClick={() => this.handlePressPoType('receipted')} disabled />
                                            </div>
                                        ))}
                                    </Form>
                                </Col>
                            </Row>
                            <Row className="mt-4">
                                <Col xs={12}>
                                    <Row>
                                        <Col xs={12}>
                                            <Calendar4 size={16} className="mb-1 mr-1" /> <label className="font-weight-bold">Order Date</label>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs={12}>
                                            <DateRangePicker
                                            startDate={this.getStartDate()}
                                            startDateId="start_date_id"
                                            endDate={this.getEndDate()}
                                            endDateId="end_date_id"
                                            onDatesChange={({ startDate, endDate }) =>
                                                this.handleDateChange(startDate, endDate)
                                            }
                                            focusedInput={this.state.focusedInput}
                                            onFocusChange={(focusedInput) => this.setState({ focusedInput })}
                                            orientation={orientation}
                                            isOutsideRange={() => false}
                                            displayFormat={() => "DD/MM/YYYY"}
                                            />
                                             <Button type="button" className="ml-3" onClick={this.handleClickOrderDate}>Search</Button>                                                            
                                        </Col>
                                    </Row>
                                    <Row className="mt-4">
                                        <Col xs={12}>
                                        <Accordion>
                                        <Accordion.Item eventKey="0">
                                            <Accordion.Header>
                                            <Search size={16} className="mb-1 mr-1" /> Advanced Filter  
                                            </Accordion.Header>
                                            <Accordion.Body>

                                            {this.state.restuarantSearchTerms &&
                                                <div className="text-right">
                                                    <Button variant="link" type="button" onClick={this.handleClickAdvancedSearchClear}>
                                                        <XCircle size={16} className="mb-1 mr-1" /> Reset
                                                    </Button>
                                                </div>
                                            }
                                        
                                            <Form>
                                                <Form.Group controlId="formGroupRestuarant">
                                                    <Form.Label className="font-weight-bold"><Shop size={16} className="mb-1 mr-1" /> Restuarant</Form.Label>
                                                    <Form.Control type="text" placeholder="Type restuarant name" value={this.state.restuarantSearchTerms} onChange={this.handleChangeRestuarantSearchTerms} />
                                                
                                                        {this.htmlRestuarantNamesListGroup()}                                                                 
                                                
                                                </Form.Group>
                                                <Button variant="secondary" type="button" className="mt-2" onClick={this.handleClickAdvancedSearchSubmit}>
                                                    Filter
                                                </Button>
                                            </Form>
                                            </Accordion.Body>
                                        </Accordion.Item>
                                        </Accordion>
                                            {/*
                                            <Accordion>
                                                <Card style={{overflow: 'inherit'}}>
                                                    <Card.Header className="p-0">
                                                        <Row>
                                                            <Col xs={6}>
                                                                <Accordion.Toggle as={Button} variant="link" eventKey="0">
                                                                    <Search size={16} className="mb-1 mr-1" /> Advanced Filter
                                                                </Accordion.Toggle>
                                                            </Col>
                                                            <Col xs={6} className="text-right">
                                                                {this.state.restuarantSearchTerms &&
                                                                <Button variant="link" type="button" onClick={this.handleClickAdvancedSearchClear}>
                                                                    <XCircle size={16} className="mb-1 mr-1" /> Reset
                                                                </Button>
                                                                }
                                                            </Col>
                                                        </Row>                                                                
                                                    </Card.Header>
                                                    <Accordion.Collapse eventKey="0">
                                                    <Card.Body>
        
                                                    <Form>
                                                        <Form.Group controlId="formGroupRestuarant">
                                                            <Form.Label className="font-weight-bold"><Shop size={16} className="mb-1 mr-1" /> Restuarant</Form.Label>
                                                            <Form.Control type="text" placeholder="Type restuarant name" value={this.state.restuarantSearchTerms} onChange={this.handleChangeRestuarantSearchTerms} />
                                                        
                                                                {this.htmlRestuarantNamesListGroup()}                                                                 
                                                        
                                                        </Form.Group>
                                                        <Button variant="secondary" type="button" onClick={this.handleClickAdvancedSearchSubmit}>
                                                            Filter
                                                        </Button>
                                                    </Form>
                                                    </Card.Body>
                                                    </Accordion.Collapse>
                                                </Card>
                                            </Accordion>
                                        */}
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                            <Row className="mt-4">
                                <Col xs={12}>
                                    <Table striped bordered hover size="sm">
                                    <thead>
                                        <tr>
                                            <th>#</th>
                                            <th><Calendar4 size={16} className="mb-1 mr-1" /> Order Date</th>
                                            <th><Shop size={16} className="mb-1 mr-1" /> Restuarant</th>
                                            <th><PersonBoundingBox size={16} className="mb-1 mr-1" /> Department</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                    {this.htmlPOReceiptTableRows()}
                                    </tbody>
                                    </Table>
                                    {paginationIntervals > 1 &&
                                        <PaginationComponent active={this.state.paginationActive} length={paginationLength} intervals={paginationIntervals} handleClickPaginationItem={this.handleClickPaginationItem} />
                                    }
                                    { 
                                        data.length === 0 && <Alert className="bg-info text-white"><ExclamationCircle size={16} className="mb-1 mr-1" />No Results</Alert>
                                    }
                                </Col>
                            </Row>
                        </div>        
                        }
                        </Col>
                    </Row>
                </Container>
            </Container>
        )
    }

}

const mapStateToProps = state => {
    const {
        auth, 
        order,
        unconfirmedDataPO,
        confirmedDataPO,
        receiptedDataPO,
        poType
    } = state;

    return {
        auth: auth, 
        order: order,
        unconfirmedDataPO:unconfirmedDataPO,
        confirmedDataPO:confirmedDataPO,
        receiptedDataPO:receiptedDataPO,
        poType:poType
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PurchaseOrderSupplier));